import SEOArticlePage from "@/components/feature/SEOArticlePage";
import { articleContents } from "@/mocks/seo-article-content";

export default function AutomatisationAvancee() {
  return <SEOArticlePage article={articleContents["automatisation-avancee"]} />;
}